import { render, staticRenderFns } from "./WhatsNewWidget.vue?vue&type=template&id=f122785c&scoped=true&"
import script from "./WhatsNewWidget.vue?vue&type=script&lang=js&"
export * from "./WhatsNewWidget.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNewWidget.vue?vue&type=style&index=0&id=f122785c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f122785c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VChip,VIcon,VProgressCircular})
